module.exports = __webpack_public_path__ + "img/login_img.e30cd71c.png";